export { ROUTES } from '@config/routes'

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'Finiva'

export const QUERY_KEYS = {
  AUTH: {
    ME: ['auth', 'me'] as const,
    SESSION: ['auth', 'session'] as const,
    SESSIONS_ADMIN: ['auth', 'sessions-admin'] as const,
  },
  DASHBOARD: {
    STATS: ['dashboard', 'stats'] as const,
  },
  MEDIA: {
    FILES: ['media', 'files'] as const,
    FOLDERS: ['media', 'folders'] as const,
  },
  AUDIT_LOGS: ['audit-logs'] as const,
  REQUEST_LOGS: ['request-logs'] as const,
  NOTIFICATIONS: {
    LIST: ['notifications', 'list'] as const,
    UNREAD_COUNT: ['notifications', 'unread-count'] as const,
    SENT: ['notifications', 'sent'] as const,
  },
  HEALTH: ['health'] as const,
} as const

export const DATE_FORMAT = {
  DISPLAY: 'dd/MM/yyyy',
  DISPLAY_TIME: 'dd/MM/yyyy HH:mm',
  ISO: "yyyy-MM-dd'T'HH:mm:ss",
} as const

export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
} as const
